import React from "react";
import Navbar from '../src/components/Navbar/Navbar'
import Home from '../src/components/Home'
import About from '../src/components/About'
import Services from '../src/components/Services/Services'
import Process from '../src/components/Process/Process'
import Clients from '../src/components/client/Clients'
import Contact from '../src/components/Contact'
import Footer from '../src/components/Footer/Footer'


function App() {
  return (
    <>
      <Navbar />
     <Home />
   <About />
       <Services />
      <Process />
     <Clients />
   <Contact />
          <Footer />  
    </>
  );
}

export default App;
